/**
 * 与 ssr-web-trade 的 K 线颜色方案保持一致：
 * - green_up: 绿涨红跌
 * - red_up: 红涨绿跌
 * 存储 key 与 trade 端一致：xt.trade.klineColorScheme
 */
const KLINE_COLOR_SCHEME_KEY = "xt.trade.klineColorScheme";

export function getKlineColorScheme() {
  if (typeof window === "undefined") return "green_up";
  try {
    const raw = localStorage.getItem(KLINE_COLOR_SCHEME_KEY);
    if (!raw) return "green_up";
    const scheme = JSON.parse(raw);
    return scheme === "red_up" || scheme === "green_up" ? scheme : "green_up";
  } catch {
    return "green_up";
  }
}

/**
 * 根据数值返回涨跌样式类名（rise=绿 fall=红，与样式表一致）
 * green_up: 正数绿 负数红；red_up: 正数红 负数绿
 * @param {number|string} value - 利润、收益率等数值
 * @param {{ rise: string, fall: string }} styles - 样式对象，含 rise、fall
 * @returns {string} 样式类名
 */
export function getProfitColorClass(value, styles) {
  if (value == null || value === "" || !styles) return "";
  const n = parseFloat(String(value).replace(/,/g, ""));
  if (Number.isNaN(n)) return "";
  const scheme = getKlineColorScheme();
  if (n > 0) return scheme === "green_up" ? styles.rise : styles.fall;
  if (n < 0) return scheme === "green_up" ? styles.fall : styles.rise;
  return "";
}

/**
 * 根据是否盈利返回盈亏样式类名（profit=绿 loss=红）
 * green_up: 盈绿亏红；red_up: 盈红亏绿
 * @param {boolean} isProfit
 * @param {{ profit: string, loss: string }} styles
 * @returns {string}
 */
export function getProfitPnlClass(isProfit, styles) {
  if (!styles) return "";
  // 兼容 0：不展示盈亏色（保持白色/中性）
  if (isProfit == null) return "";
  const scheme = getKlineColorScheme();
  if (isProfit) return scheme === "green_up" ? styles.profit : styles.loss;
  return scheme === "green_up" ? styles.loss : styles.profit;
}
